<template>
  <!--
      作者：kmdshop
      时间：2020-06-20
      描述：diy组件-参数设置
    -->
  <div id="diy-editor" ref="diy-editor" class="diy-editor form-horizontal">
    <template v-show="diyData.items.length && form.curItem">
      <!--顶部设置-->
      <template v-if="form.curItem.type == 'page'">
        <Setpages :curItem="form.curItem"></Setpages>
      </template>
      <!--搜索栏-->
      <template v-if="form.curItem.type == 'search'">
        <Search :curItem="form.curItem"></Search>
      </template>
      <!--图片轮播-->
      <template v-if="form.curItem.type == 'banner'">
        <Banner
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Banner>
      </template>
      <!--全分类-->
      <template v-if="form.curItem.type == 'categorya'">
        <Categorya
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Categorya>
      </template>
      <!-- diy导航组 -->
      <template v-if="form.curItem.type == 'navDiy'">
        <NavDiy
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></NavDiy>
      </template>
      
       <!--热门视频-->
       <template v-if="form.curItem.type == 'hotvideo'">
        <Hotvideo
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Hotvideo>
      </template>
       <!-- 热门活动 -->
       <template v-if="form.curItem.type == 'hotactivity'">
        <Hotactivity
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Hotactivity>
      </template>
       <!--财富机遇-->
       <template v-if="form.curItem.type == 'hotproject'">
        <Hotproject    
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Hotproject>
      </template>
      <!--图片-->
      <template v-if="form.curItem.type == 'imageSingle'">
        <ImageSingle
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></ImageSingle>
      </template>
      <!--图片橱窗-->
      <template v-if="form.curItem.type == 'window'">
        <Window
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Window>
      </template>
      <!--视频组件-->
      <template v-if="form.curItem.type == 'video'">
        <Video
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Video>
      </template>
      <!--文章组件-->
      <template v-if="form.curItem.type == 'article'">
        <Article
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Article>
      </template>
      <!--头条快报-->
      <template v-if="form.curItem.type == 'special'">
        <Special
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Special>
      </template>
      <!--公告组-->
      <template v-if="form.curItem.type == 'notice'">
        <Notice
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Notice>
      </template>
      <!--导航组-->
      <template v-if="form.curItem.type == 'navBar'">
        <NavBar
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></NavBar>
      </template>
      <!--菜单组-->
      <template v-if="form.curItem.type == 'menu'">
        <Menu
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Menu>
      </template>
      <!--商品组-->
      <template v-if="form.curItem.type == 'product'">
        <Product
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Product>
      </template>
      <!--优势-->
      <template v-if="form.curItem.type == 'advantage'">
        <Advantage
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Advantage>
      </template>
      <!--优惠券-->
      <template v-if="form.curItem.type == 'coupon'">
        <Coupon
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Coupon>
      </template>
            <!--立即开始-->
      <template v-if="form.curItem.type == 'start'">
        <Start
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Start>
      </template> 
                <!--标注流程-->
      <template v-if="form.curItem.type == 'process'">
        <Process
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Process>
      </template> 
                    <!--标注流程-->
      <template v-if="form.curItem.type == 'mainstream'">
        <Mainstream
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Mainstream>
      </template> 
           <template v-if="form.curItem.type == 'ser'">
        <Ser
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Ser>
      </template> 

         </template> 
           <template v-if="form.curItem.type == 'industry'">
        <Industry
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Industry>
      </template> 
      
      
                         <!--标注流程-->
      <template v-if="form.curItem.type == 'feedback'">
        <Feedback
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Feedback>
      </template>
      <!--门店-->
      <template v-if="form.curItem.type == 'store'">
        <Store
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Store>
      </template>
      <!--客服-->
      <template v-if="form.curItem.type == 'service'">
        <Service
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Service>
      </template>
      <!--富文本-->
      <template v-if="form.curItem.type == 'richText'">
        <RichText
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></RichText>
      </template>
      <!--辅助空白-->
      <template v-if="form.curItem.type == 'blank'">
        <Blank
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Blank>
      </template>
      <!--辅助线-->
      <template v-if="form.curItem.type == 'guide'">
        <Guide
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Guide>
      </template>
      <!--秒杀-->
      <template v-if="form.curItem.type == 'seckillProduct'">
        <Seckill
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Seckill>
      </template>
      <!--拼团-->
      <template v-if="form.curItem.type == 'assembleProduct'">
        <assembleProduct
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></assembleProduct>
      </template>
      <!--砍价-->
      <template v-if="form.curItem.type == 'bargainProduct'">
        <BargainProduct
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></BargainProduct>
      </template>
      <!--积分商品-->
      <template v-if="form.curItem.type == 'pointsProduct'">
        <PointsProduct :curItem="form.curItem" :selectedIndex="form.selectedIndex"></PointsProduct>
      </template>
      <!--微信直播-->
      <template v-if="form.curItem.type == 'wxlive'">
        <Wxlive
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Wxlive>
      </template>

      <!--选项卡-->
      <template v-if="form.curItem.type == 'option'">
        <Option
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Option>
      </template>

      <!-- 底部菜单 -->
      <template v-if="form.curItem.type == 'tabBar'">
        <TabBar
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></TabBar>
      </template>

      <!-- 用户信息 -->
      <template v-if="form.curItem.type == 'userinfo'">
        <UserInfo
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></UserInfo>
      </template>

      <!-- 巨幕 -->
      <!-- <template v-if="form.curItem.type == 'huge'">
        <Huge
          :curItem="form.curItem"
          :selectedIndex="form.selectedIndex"
        ></Huge>
      </template> -->
    <!-- </template> -->

    <!--上传图片-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :config="{ total: 3 }"
      @returnImgs="returnImgsFunc"
    ></Upload>

    <!--选择商品-->
    <ProductSelect
      :isproduct="isproduct"
      :excludeIds="excludeIds"
      :islist="islist"
      @closeDialog="closeProductDialogFunc($event)"
      >产品列表弹出层</ProductSelect
    >
    <PointProductSelect :isproduct="ispointproduct" :excludeIds="excludePointIds" :islist="islist" @closeDialog="closeProductDialogFunc($event,'point')">产品列表弹出层</PointProductSelect>

    <!--选择门店-->
    <StoreSelect :isstore="isstore" :islist="isstorelist"></StoreSelect>
  </div>
</template>

<script>
import { deepClone } from "@/utils/base.js";
import Setpages from "./params/Setpages2.vue";
import Search from "./params/Search.vue";
import Banner from "./params/Banner.vue";
import Categorya from "./params/Categorya.vue";
import Hotvideo from "./params/Hotvideo.vue";
import Hotactivity from "./params/Hotactivity.vue";
import Hotproject from "./params/Hotproject.vue";
import NavDiy from "./params/navDiy.vue";

import ImageSingle from "./params/ImageSingle.vue";
import Window from "./params/Window.vue";
import Video from "./params/Video.vue";
import Article from "./params/Article.vue";
import Special from "./params/Special.vue";
import Notice from "./params/Notice.vue";
import NavBar from "./params/NavBar.vue";
import Product from "./params/Product.vue";  
import Advantage from "./params/Advantage.vue"; 
import Coupon from "./params/Coupon.vue"; 
import Start from "./params/Start.vue"; 
import Process from "./params/Process.vue";
import Store from "./params/Store.vue";
import Service from "./params/Service.vue"; 
import Mainstream from "./params/Mainstream.vue"; 
import Ser from "./params/Ser.vue"; 
import Feedback from "./params/Feedback.vue"; 
import Industry from "./params/Industry.vue"; 
import RichText from "./params/RichText.vue";
import Blank from "./params/Blank.vue";
import Guide from "./params/Guide.vue";
import Seckill from "./params/Seckill.vue";
import assembleProduct from "./params/assembleProduct.vue";
import BargainProduct from "./params/BargainProduct.vue";
import Wxlive from "./params/Wxlive.vue";
import Option from "./params/Option.vue";
import Menu from "./params/Menu.vue";
import Upload from "@/components/file/Upload";
import ProductSelect from "@/components/product/Product";
import PointProductSelect from '@/components/product/PointsProduct';
import PointsProduct from './params/PointsProduct.vue';
import StoreSelect from "@/components/store/StoreSelect";
import TabBar from "./params/TabBar.vue";
import UserInfo from "./params/UserInfo.vue";
// import Huge from "./params/Huge.vue";

export default {
  components: {
    /*顶部设置*/
    Setpages,
    /*搜索组件*/
    Search,
    /*图片轮播组件*/
    Banner,
    Industry,
    // 全分类组件
    Categorya,
    //热门活动
    Hotactivity,
     //热门视频
     Hotvideo,
      //财富机遇
      Hotproject,
      Ser,
    /*图片组件*/
    ImageSingle,
    /*图片橱窗*/
    Window,
    /*视频*/
    Video,
    /*文章*/
    Article,
    /*文章*/
    Special,
    /*公告组*/
    Notice,
    /*导航组*/
    NavBar,
    /*商品组*/
    Product,
    Advantage,
    /*优惠券*/
    Coupon,
    Start,
    Process,
    /*门店*/
    Store,
    /*客服*/
    Service,
    Mainstream, 
    Feedback,
    /*富文本*/
    RichText,
    /*辅助空白*/
    Blank,
    /*辅助线*/
    Guide,
    /*秒杀*/
    Seckill,
    /*拼团*/
    assembleProduct,
    /*砍价*/
    BargainProduct,
    /*上传图片*/
    Upload,
    /*商品选择*/
    ProductSelect,
    PointProductSelect,
    PointsProduct,
    /*门店选中*/
    StoreSelect,
    /*微信直播*/
    Wxlive,
    /* 选项卡 */
    Option,
    // 菜单
    Menu,
    /* 底部菜单 */
    TabBar,
    /* 用户信息 */
    UserInfo,
    /* 巨幕 */
    // Huge,
    // diy导航组
    NavDiy
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      /*图片当前对象*/
      imgModel: null,
      /*是否打开产品弹出层*/
      isproduct: false,
      ispointproduct: false,
      /*商品需要去重的*/
      excludeIds: [],
      /*是否多选*/
      islist: false,
      /*是否显示门店选中*/
      isstore: false,
      /*门店是否多选*/
      isstorelist: false,
    };
  },
  props: ["form", "defaultData", "diyData", "opts"],
  created() {},
  methods: {
    /**
     * 编辑器：添加data元素
     */
    onEditorAddData: function (type = "pic") {
      let self = this;
      self.defaultData[self.form.curItem.type].data[0].type = type;
      // 新增data数据
      var newDataItem = deepClone(
        self.defaultData[self.form.curItem.type].data[0]
      );

      self.form.curItem.data.push(newDataItem);
    },
    /**
     * 编辑器：重置颜色
     * @param holder
     * @param attribute
     * @param color
     */
    onEditorResetColor: function (holder, attribute, color) {
      holder[attribute].titleBackgroundColor = color;
    },
    /**
     * 编辑器：删除data元素
     * @param index
     * @param selectedIndex
     */
    onEditorDeleleData: function (index, selectedIndex) {
      let self = this;
      if (self.diyData.items[selectedIndex].data.length <= 1) {
        self.$message({
          message: "至少保留一个",
          type: "error",
        });
        return false;
      }
      self.diyData.items[selectedIndex].data.splice(index, 1);
    },
    /* 删除options下的商品 */
    onEditorDeleleOptionGoodsData: function (index, itemIndex, selectedIndex) {
      let self = this;
      self.diyData.items[selectedIndex].data[itemIndex].goodsdata.splice(
        index,
        1
      );
      console.log(self.diyData.items[selectedIndex]);
    },
    /**
     * 编辑器：选择图片
     * @param source
     * @param index
     */
    onEditorSelectImage: function (index, imgUrl) {
      this.isupload = true;
      this.imgModel = {
        index: index,
        imgUrl: imgUrl,
      };
    },

    /*上传图片*/
    returnImgsFunc(e) {
      if (e != null) {
        this.imgModel.index[this.imgModel.imgUrl] = e[0]["file_path"];
      }
      console.log(11111,this.imgModel.index)
      this.isupload = false;
    },

    /*商品选择列表弹出层*/
    openProduct(list, islist) {
      let arr = [];
      list.forEach((item) => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      if (islist && typeof islist != "undefined") {
        this.islist = true;
      } else {
        this.islist = false;
      }
      this.isproduct = true;
    },

    /*商品选择关闭弹窗*/
    closeProductDialogFunc(e,source='') {
      if (this.form.curItem == null) {
        return;
      }
       var product = [];
      console.log(e.params)
      if(e.params){
        e.params.forEach(item=>{
          var temp = {};
          if(source=='point'){
            temp.product_name=item.product_name;
            temp.image=item.image;
            temp.product_sales=item.total_sales;
            temp.point_money=item.point_money;
            temp.point_num=item.point_num;
            temp.point_product_id=item.point_product_id;
          }else{
            temp.product_name=item.product_name;
            temp.image=item.image;
            temp.product_price=item.product_sku.product_price;
            temp.line_price=item.product_sku.line_price;
            temp.product_sales=item.product_sales;
            temp.selling_point=item.selling_point;
            temp.product_id=item.product_id;
          }
          
          product.push(temp)
        });
      }
      this.isproduct = false;
      this.ispointproduct = false;
      if (e.type == "success") {
        if (this.islist) {
          this.form.curItem.data = this.form.curItem.data.concat(e.params);
        } else {
          this.form.curItem.data.push(e.params);
        }
      }
    },
    /*积分商品选择列表弹出层*/
    openPointProduct(list, islist) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.point_product_id);
      });
      this.excludePointIds = arr;
      if (islist && typeof islist != 'undefined') {
        this.islist = true;
      } else {
        this.islist = false;
      }
      this.ispointproduct = true;
    },

    /*商品选择列表弹出层*/
    openStore(list, islist) {
      let arr = [];
      list.forEach((item) => {
        arr.push(item.store_id);
      });
      this.excludeIds = arr;
      if (islist && typeof islist != "undefined") {
        this.isstorelist = true;
      } else {
        this.isstorelist = false;
      }
      this.isstore = true;
    },
  },
};
</script>

<style>
.param-img-item {
  position: relative;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #eeeeee;
  line-height: 20px;
}
.param-img-item .delete-box {
  z-index: 99;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  color: #cccccc;
}
.param-img-item .delete-box:hover {
  color: rgb(255, 51, 0);
}
.param-img-item .pic img {
  width: 200px;
  height: 100px;
  margin: 0 auto;
}
.param-img-item .icon img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}
.param-img-item .url-box {
  display: flex;
  justify-content: flex-start;
  line-height: 40px;
}
.param-img-item .url-box .key-name {
  display: block;
  width: 95px;
}
.param-img-item .url-box .el-input {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/Params.vue